/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PagingDtoFromJSON, PagingDtoToJSON, } from './PagingDto';
/**
 * @export
 */
export const VwStoricoAnnoSearchDtoSortDirectionEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
};
/**
 * Check if a given object implements the VwStoricoAnnoSearchDto interface.
 */
export function instanceOfVwStoricoAnnoSearchDto(value) {
    return true;
}
export function VwStoricoAnnoSearchDtoFromJSON(json) {
    return VwStoricoAnnoSearchDtoFromJSONTyped(json, false);
}
export function VwStoricoAnnoSearchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fkChiaveMisura': json['fkChiaveMisura'] == null ? undefined : json['fkChiaveMisura'],
        'dataSnapshot': json['dataSnapshot'] == null ? undefined : (new Date(json['dataSnapshot'])),
        'sortDirection': json['sortDirection'] == null ? undefined : json['sortDirection'],
        'paging': json['paging'] == null ? undefined : PagingDtoFromJSON(json['paging']),
    };
}
export function VwStoricoAnnoSearchDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'fkChiaveMisura': value['fkChiaveMisura'],
        'dataSnapshot': value['dataSnapshot'] == null ? undefined : ((value['dataSnapshot']).toISOString().substring(0, 10)),
        'sortDirection': value['sortDirection'],
        'paging': PagingDtoToJSON(value['paging']),
    };
}
